"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapHeaderItemToListMenuItem = exports.generateSandwichMenu = void 0;
const generateSandwichMenu = ({ isLoggedIn, loginUrl = null, headerLinks }) => {
    const unFlattenedMenuItems = headerLinks.map((item) => {
        if (item === null || item === void 0 ? void 0 : item.items) {
            return [
                { type: 'divider' },
                { type: 'header', text: item.label }
            ]
                .concat(item.items)
                .concat([{ type: 'divider' }]);
        }
        return (0, exports.mapHeaderItemToListMenuItem)(item);
    });
    let menuItems = removeUnneededDividers(flatten(unFlattenedMenuItems));
    if (isLoggedIn)
        return menuItems;
    const loginItem = {
        type: "item",
        text: "Log In",
        link: { url: loginUrl },
        itemId: "__LOGIN_ITEM_ID__",
    };
    return addLoginToMenuItems(menuItems, loginItem);
};
exports.generateSandwichMenu = generateSandwichMenu;
const flatten = (arr) => {
    return [].concat.apply([], arr);
};
const addLoginToMenuItems = (menuItems, loginItem) => {
    if (menuItems.length === 0)
        return [loginItem];
    return menuItems.concat([{ type: "divider" }, loginItem]);
};
const mapHeaderItemToListMenuItem = ({ label, link, isActiveRoute = false, newTab, }) => ({
    type: "item",
    itemId: label + link,
    text: label,
    link: { url: link, newTab },
    active: isActiveRoute,
});
exports.mapHeaderItemToListMenuItem = mapHeaderItemToListMenuItem;
const removeUnneededDividers = (list) => {
    let indexesToRemove = [];
    let lastItemType = '';
    list.forEach((item, index) => {
        if (item.type === 'divider') {
            if (index === 0)
                indexesToRemove.push(0);
            if (lastItemType === 'divider')
                indexesToRemove.push(index);
            if (index === list.length - 1)
                indexesToRemove.push(index);
        }
    });
    return list.filter((_, index) => !indexesToRemove.includes(index));
};
//# sourceMappingURL=generateSandwichMenu.js.map